import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import axios from 'axios';

const MemberForceChangePassword = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    // Check if member is logged in and needs to change password
    const member = JSON.parse(localStorage.getItem('member') || '{}');
    const memberToken = localStorage.getItem('member_token');
    
    if (!memberToken) {
      // Not logged in, redirect to login
      navigate('/member-login', { replace: true });
      return;
    }
    
    if (!member.must_change_password) {
      // Password already changed, redirect to portal
      navigate('/member-portal', { replace: true });
      return;
    }
  }, [navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // Validation
    if (newPassword.length < 6) {
      toast.error('Yeni şifre en az 6 karakter olmalıdır');
      return;
    }
    
    if (newPassword !== confirmPassword) {
      toast.error('Şifreler eşleşmiyor');
      return;
    }
    
    setLoading(true);

    try {
      const member = JSON.parse(localStorage.getItem('member') || '{}');
      
      const response = await axios.post(
        `${BACKEND_URL}/api/member-auth/force-change-password`,
        {
          phone: member.phone,
          reset_code: currentPassword,  // Using reset_code field for current password
          new_password: newPassword
        }
      );

      const { access_token, member: updatedMember } = response.data;
      
      // Update stored member data
      localStorage.setItem('member_token', access_token);
      localStorage.setItem('member', JSON.stringify(updatedMember));
      
      toast.success('Şifreniz başarıyla değiştirildi!');
      navigate('/member-portal');
    } catch (error: any) {
      toast.error(error.response?.data?.detail || 'Şifre değiştirme başarısız');
    } finally {
      setLoading(false);
    }
  };

  const member = JSON.parse(localStorage.getItem('member') || '{}');

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-[#6b0f1a] mb-2">Şifre Değiştirin</h1>
            <p className="text-gray-600 mb-4">Hoş geldiniz, {member.name}</p>
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 text-sm text-gray-700">
              <p className="font-semibold mb-2">İlk giriş için şifrenizi değiştirmeniz gerekmektedir.</p>
              <p className="text-xs">Varsayılan şifreniz: <span className="font-mono bg-yellow-100 px-2 py-1 rounded">Seans1234</span></p>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Mevcut Şifre
              </label>
              <input
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#6b0f1a] focus:border-transparent"
                placeholder="Seans1234"
                required
                data-testid="current-password-input"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Yeni Şifre
              </label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#6b0f1a] focus:border-transparent"
                minLength={6}
                required
                data-testid="new-password-input"
              />
              <p className="text-xs text-gray-500 mt-1">En az 6 karakter olmalıdır</p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Yeni Şifre (Tekrar)
              </label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#6b0f1a] focus:border-transparent"
                minLength={6}
                required
                data-testid="confirm-password-input"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#6b0f1a] text-white py-3 rounded-lg font-semibold hover:bg-[#8a1422] disabled:opacity-50 transition-colors"
              data-testid="change-password-button"
            >
              {loading ? 'Değiştiriliyor...' : 'Şifreyi Değiştir'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default MemberForceChangePassword;
